const explicitZone = /(?:Z|[+-]\d{2}:?\d{2})$/i
const partsFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Shanghai',
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
})

// JDBC Timestamp 返回的 ISO 字符串可能带 UTC 偏移；LocalDateTime 没有偏移，按北京时间解释。
export function parseBeijingDateTime(value) {
  if (value == null || value === '') return null
  if (typeof value === 'number') {
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value
  const raw = String(value).trim().replace(' ', 'T')
  const local = raw.includes('T') ? raw : `${raw}T00:00:00`
  const parsed = new Date(explicitZone.test(local) ? local : `${local}+08:00`)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function beijingParts(value) {
  const date = parseBeijingDateTime(value)
  if (!date) return null
  return Object.fromEntries(partsFormatter.formatToParts(date)
    .filter(part => part.type !== 'literal')
    .map(part => [part.type, part.value]))
}

export function beijingWallTime(value) {
  const parts = beijingParts(value)
  if (!parts) return null
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`
}

export function formatBeijingDateTime(value, withSeconds = false) {
  const wallTime = beijingWallTime(value)
  if (!wallTime) return '—'
  const text = wallTime.replace('T', ' ')
  return withSeconds ? text : text.slice(0, 16)
}

export function addAnchoredBeijingMonths(value, offset) {
  const wallTime = beijingWallTime(value)
  if (!wallTime) return null
  const [date, time] = wallTime.split('T')
  const [year, month, day] = date.split('-').map(Number)
  const lastDay = new Date(Date.UTC(year, month + offset, 0)).getUTCDate()
  const result = new Date(Date.UTC(year, month - 1 + offset, Math.min(day, lastDay)))
  return `${result.toISOString().slice(0, 10)}T${time}`
}
